import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { AIButtonContainedDark } from '../../AIButton'
import { BUTTON_HEIGHT_32 } from '../../Button'
import { ICON_HEIGHT_16 } from '../../Icon'
import {
  GRETA_AI_CHAT_SOURCE_TEXT_KEYS,
  QA_NAME_GRETA_AI_CHAT_ASK_ELSEWHERE,
} from '../GretaAIChat.constants'
import { getIsGretaAIChatFinanceSource } from '../GretaAIChat.utils.source'

import * as styles from './GretaAIChatAskElsewhere.module.css'

import ChevronRightIcon from '../../../icons/chevrons/right.svg'

function GretaAIChatAskElsewhere({ target, onAsk = EMPTY_FUNCTION }) {
  const { t } = useTranslation()

  const { askElsewhereKey } = GRETA_AI_CHAT_SOURCE_TEXT_KEYS[target]

  const buttonClassName = classNames(styles.button, {
    [styles.toFinance]: getIsGretaAIChatFinanceSource(target),
  })

  return (
    <AIButtonContainedDark
      afterIconProps={{ Icon: ChevronRightIcon, height: ICON_HEIGHT_16 }}
      className={buttonClassName}
      height={BUTTON_HEIGHT_32}
      qaName={QA_NAME_GRETA_AI_CHAT_ASK_ELSEWHERE}
      text={t(askElsewhereKey)}
      onClick={onAsk}
    />
  )
}

export default GretaAIChatAskElsewhere
